import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo } from 'react';
import * as Components from '.';
import { forgePropsAreEqual } from '../utils/forgePropsAreEqual';
export var importMap = {
  BarChart: function BarChart(args) {
    return /*#__PURE__*/React.createElement(Components.BarChart, args);
  },
  StackBarChart: function StackBarChart(args) {
    return /*#__PURE__*/React.createElement(Components.StackBarChart, args);
  },
  HorizontalStackBarChart: function HorizontalStackBarChart(args) {
    return /*#__PURE__*/React.createElement(Components.HorizontalStackBarChart, args);
  },
  HorizontalBarChart: function HorizontalBarChart(args) {
    return /*#__PURE__*/React.createElement(Components.HorizontalBarChart, args);
  },
  LineChart: function LineChart(args) {
    return /*#__PURE__*/React.createElement(Components.LineChart, args);
  },
  PieChart: function PieChart(args) {
    return /*#__PURE__*/React.createElement(Components.PieChart, args);
  },
  DonutChart: function DonutChart(args) {
    return /*#__PURE__*/React.createElement(Components.DonutChart, args);
  }
};
export var importMapChartsMemo = Object.entries(importMap).reduce(function (agg, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    Component = _ref2[1];
  agg[key] = /*#__PURE__*/memo(Component, forgePropsAreEqual);
  return agg;
}, {});